import 'reactjs-popup/dist/index.css';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';
import { useRefs } from 'contexts/RefContext';
import { setConfirmedExceedAzimuthWarningFacet, setInvalidAzimuthFacet, 
	setPendingAzimuthConfirmationFacet, setRoofIndexes, setSelectedRoofAzimuth } from 'store/slices/ToolSlice';
import { debounce } from '../../../../util';
import { getExistingPanelsGroupID, rotateKonvaShapeAroundCenter } from 'components/tool/utils';
import Konva from 'konva';
import { AZIMUTH_CONSTRAINT_DEFAULT_MODE } from '../../../../constants';
import ConfirmationModal from 'components/Basic/Modal/Confirmation';

export default function AzimuthExceedWarningModal() {
	const dispatch = useDispatch();
	const { konvaRef } = useRefs();
	const { allRoofSegs } = useSelector((state: RootState) => state.roofData.data);
	const { pendingAzimuthConfirmationFacet, roofIndexes } = useSelector((state: RootState) => state.toolNewPostions.data);
	
	const handleAzimuthConfirm = () => {
		if (!pendingAzimuthConfirmationFacet) return;
		dispatch(setInvalidAzimuthFacet({ facetName: pendingAzimuthConfirmationFacet, invalid: false }));
		dispatch(setConfirmedExceedAzimuthWarningFacet({ facetName: pendingAzimuthConfirmationFacet }));
		dispatch(setPendingAzimuthConfirmationFacet({ facetName: null }));
	};
	
	const handleAzimuthCancel = () => {
		if (!pendingAzimuthConfirmationFacet) return;
		const initialAzimuth = allRoofSegs.find((r) => r.id === pendingAzimuthConfirmationFacet)?.azimuthDegrees ?? 0;
		dispatch(setSelectedRoofAzimuth({ selectedRoofAzimuth: initialAzimuth }));
		dispatch(setInvalidAzimuthFacet({ facetName: pendingAzimuthConfirmationFacet, invalid: false }));
		dispatch(setPendingAzimuthConfirmationFacet({ facetName: null }));
		dispatch(setRoofIndexes({ roofIndexes: roofIndexes.filter((index) => index !== pendingAzimuthConfirmationFacet) }));
		debounce(() => {
			const transformer = konvaRef?.current?.findOne('.azimuth_rotator') as Konva.Transformer;
			const panelGroup = konvaRef?.current?.findOne(`#${getExistingPanelsGroupID(pendingAzimuthConfirmationFacet)}`) as Konva.Group;
			if (!panelGroup || !transformer || !panelGroup.hasChildren()) return;
			const attrs = transformer._getNodeRect();
			const diff = initialAzimuth - transformer.getAbsoluteRotation();
			const shape = rotateKonvaShapeAroundCenter(attrs, diff * (Math.PI / 180));
			transformer._fitNodesInto(shape);
		}, 25)();
	};

	return (
		<ConfirmationModal
			open={!!pendingAzimuthConfirmationFacet}
			heading="Confirm Action"
			message={`You're changing the azimuth by more than ${AZIMUTH_CONSTRAINT_DEFAULT_MODE}° from the detected value. Please confirm before proceeding.`}
			onConfirm={handleAzimuthConfirm}
			onCancel={handleAzimuthCancel}
			confirmLabel="Proceed Anyway"
			cancelLabel="Discard Changes"
		/>
	);
}
